var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { overlayHeader } from '../../helpers/elements.js';
import { Modal } from 'flowbite';
import { adminMessageShown$, bottomSheet$, modal$, stpShortTitles$, } from '../../stores/store-main.js';
import { hideModalOnOutsideClick, scrollingElement } from '../../helpers/dom.js';
import { classMap } from 'lit/directives/class-map.js';
import '../element-contact-form.js';
import { clearHighlight } from '../../proxies/proxy-highlight.js';
import { monitorLoadingError } from '../../initialization/obsoleteApi.js';
import { validateOidcUserToken } from '../../helpers/oidcUser.js';
import { SubscriptionsController } from '../../helpers/SubscriptionsController.js';
let ElementOverlay = class ElementOverlay extends LitElement {
    constructor() {
        super(...arguments);
        this.adminMessageShown = adminMessageShown$.getValue();
        this.showHeader = true;
        this.notificationDialog = false;
        this.titleCloseText = true;
        this.galleryOpen = false;
        this.subscriptionController = new SubscriptionsController(this, () => [
            adminMessageShown$.subscribe((shown) => (this.adminMessageShown = shown)),
            modal$.subscribe((options) => {
                if (options &&
                    !(options.type === 'confirm' && options.data.id === 'delete-filter') &&
                    bottomSheet$.value) {
                    bottomSheet$.next(undefined);
                }
                if (options?.type === 'contact') {
                    this.options = options;
                    this.overlayTitle = undefined;
                    if (this.modal)
                        this.showModal();
                }
                else if (options?.type === 'staticPage') {
                    monitorLoadingError(import('./element-static-overlay-content.js'));
                    this.options = options;
                    this.pageKey = options?.value;
                    this.showHeader = false;
                    if (this.modal)
                        this.showModal();
                }
                else if (options?.type === 'goToOldMapOrLogin' ||
                    options?.type === 'sharedTourNotification') {
                    monitorLoadingError(import('./element-account-info-login-enabled.js'));
                    this.options = options;
                    this.titleCloseText = false;
                    this.headerMaxScreenSizeCode = 'sm';
                    if (this.modal)
                        this.showModal();
                }
                else if (options?.type === 'confirm') {
                    monitorLoadingError(import('./element-dialog-content.js'));
                    this.options = options;
                    this.titleCloseText = false;
                    this.overlayTitle = html `
          <div class="font-bold">${options.data.title}</div>
        `;
                    this.notificationDialog = true;
                    if (this.modal)
                        this.showModal();
                }
                else if (options?.type === 'importGpx') {
                    validateOidcUserToken().then((validToken) => {
                        if (!validToken)
                            return;
                        monitorLoadingError(import('./element-import-gpx-popup.js'));
                        this.options = options;
                        this.showHeader = false;
                        if (this.modal) {
                            this.showModal();
                        }
                    });
                }
                else if (options?.type === 'gallery') {
                    this.galleryOpen = true;
                }
                else if (this.options && !this.galleryOpen) {
                    if (this.modal.isVisible()) {
                        this.modal.hide();
                    }
                    if (this.options?.type === 'staticPage')
                        stpShortTitles$.next(undefined);
                    this.options = undefined;
                    this.titleCloseText = true;
                    this.notificationDialog = false;
                    clearHighlight(false);
                }
                else {
                    this.galleryOpen = false;
                }
                if (options === undefined) {
                    this.showHeader = true;
                    this.notificationDialog = false;
                    this.titleCloseText = true;
                    this.headerMaxScreenSizeCode = undefined;
                }
            }),
        ]);
    }
    showModal() {
        this.modal.show();
        hideModalOnOutsideClick();
    }
    renderContentFactory() {
        switch (this.options.type) {
            case 'contact':
                return html ` <element-contact-form
          .overlayContent=${true}
        ></element-contact-form>`;
            case 'staticPage':
                return html ` <element-static-overlay-content
          .pageKey=${this.pageKey}
          @close=${() => modal$.next(undefined)}
        >
        </element-static-overlay-content>`;
            case 'confirm':
                return html `<element-dialog-content
          .options="${{
                    text: this.options.data.text,
                    confirmBtnText: this.options.data.confirmBtnText,
                    cancelBtnText: this.options.data.cancelBtnText,
                    onConfirm: this.options.data.onConfirm,
                    onCancel: this.options.data.onCancel,
                }}"
          @close=${() => {
                    if (this.options?.type === 'confirm' &&
                        this.options?.data?.onClose) {
                        this.options.data.onClose();
                    }
                    modal$.next(undefined);
                }}
        ></element-dialog-content>`;
            case 'importGpx':
                return html `<element-import-gpx-popup
          @close=${() => modal$.next(undefined)}
        >
        </element-import-gpx-popup>`;
            case 'goToOldMapOrLogin':
                return html `<element-account-info-login-enabled
          type="goToOldMapOrLogin"
          @close=${() => modal$.next(undefined)}
        >
        </element-account-info-login-enabled>`;
            case 'sharedTourNotification':
                return html `<element-account-info-login-enabled
          type="sharedTourNotification"
          @close=${() => modal$.next(undefined)}
        >
        </element-account-info-login-enabled>`;
            default:
                return '';
        }
    }
    render() {
        return html `
      <div
        id="element-${this.options.type}-modal"
        tabindex="-1"
        class="popup ${classMap({
            message: this.adminMessageShown,
            'popup-content-old-map-or-login-overlay': this.options.type === 'goToOldMapOrLogin' ||
                this.options.type === 'sharedTourNotification',
        })} hidden"
      >
        <div
          id="popup-content"
          class="${classMap({
            'popup-content': ![
                'importGpx',
                'goToOldMapOrLogin',
                'sharedTourNotification',
            ].includes(this.options.type),
            'popup-content-import-tour': this.options.type === 'importGpx',
            'xl:popup-content-old-map-or-login-xl': [
                'goToOldMapOrLogin',
                'sharedTourNotification',
            ].includes(this.options.type),
            'popup-content-old-map-or-login': [
                'goToOldMapOrLogin',
                'sharedTourNotification',
            ].includes(this.options.type),
            message: this.adminMessageShown,
            'notification-dialog': this.notificationDialog,
        })}"
          @scroll="${(event) => (this.isScrolled = scrollingElement(event))}"
        >
          ${this.showHeader
            ? overlayHeader({
                title: this.overlayTitle,
                scrolled: this.isScrolled,
                closeText: this.titleCloseText,
                onClose: this.options?.type === 'confirm'
                    ? this.options.data?.onClose
                    : undefined,
                maxScreenSizeCode: this.headerMaxScreenSizeCode,
            })
            : ''}
          ${this.renderContentFactory()}
        </div>
      </div>
    `;
    }
    shouldUpdate() {
        return this.options !== undefined;
    }
    firstUpdated() {
        this.modal = new Modal(this.querySelector(`#element-${this.options.type}-modal`), {
            placement: 'center',
            onHide: () => modal$.next(undefined),
            onShow: () => {
                if (this.options?.type === 'sharedTourNotification') {
                    this.modal._backdropEl.classList.add('hidden');
                }
                else {
                    this.modal._backdropEl.classList.remove('hidden');
                }
            },
            backdropClasses: 'modal-backdrop bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-[55]',
        });
        this.showModal();
    }
    updated(changedProperties) {
        if (changedProperties.has('options'))
            this.querySelector('#popup-content').scrollTo(0, 0);
        super.updated(changedProperties);
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    state()
], ElementOverlay.prototype, "options", void 0);
__decorate([
    state()
], ElementOverlay.prototype, "isScrolled", void 0);
__decorate([
    state()
], ElementOverlay.prototype, "adminMessageShown", void 0);
__decorate([
    state()
], ElementOverlay.prototype, "showHeader", void 0);
__decorate([
    state()
], ElementOverlay.prototype, "headerMaxScreenSizeCode", void 0);
__decorate([
    state()
], ElementOverlay.prototype, "notificationDialog", void 0);
__decorate([
    state()
], ElementOverlay.prototype, "titleCloseText", void 0);
__decorate([
    state()
], ElementOverlay.prototype, "overlayTitle", void 0);
ElementOverlay = __decorate([
    customElement('element-overlay')
], ElementOverlay);
export default ElementOverlay;
//# sourceMappingURL=element-overlay.js.map